import React from 'react';
import { Link } from 'react-router-dom';
import TablePagination from '../components/TablePagination';
import { useTablePagination } from '../hooks/useTablePagination';
import MetricHeader from '../components/MetricHeader';

type QualityStatus = '好' | '一般' | '—';
type NullableNumber = number | null;

interface MeetingQuality {
  status: QualityStatus;
  score?: number;
}

interface MeetingRecord {
  id: string;
  topic: string;
  creator: string;
  account: string;
  overall: MeetingQuality;
  audio: MeetingQuality;
  video: MeetingQuality;
  screen: MeetingQuality;
  network: MeetingQuality;
  loginSuccessRate: NullableNumber;
  audioStutterRate: NullableNumber;
  audioStutterCount: NullableNumber;
  videoStutterRate: NullableNumber;
  videoStutterCount: NullableNumber;
  screenStutterRate: NullableNumber;
  screenStutterCount: NullableNumber;
  avgLatencyMs: NullableNumber;
  reconnectCount: NullableNumber;
  startTime: string;
  endTime: string;
  duration: string;
  participants: number;
  videoEnabled: boolean;
  screenEnabled: boolean;
  recordEnabled: boolean;
}

export const historicalMeetingRecords: MeetingRecord[] = [
  {
    id: '624521',
    topic: '张茜琳的快速会议',
    creator: '张茜琳',
    account: 'zhanglinglin',
    overall: { status: '好', score: 99.63 },
    audio: { status: '好', score: 100 },
    video: { status: '—' },
    screen: { status: '好', score: 99 },
    network: { status: '好', score: 99.89 },
    loginSuccessRate: 99.86,
    audioStutterRate: 0.45,
    audioStutterCount: 1,
    videoStutterRate: 0.45,
    videoStutterCount: 1,
    screenStutterRate: 0.45,
    screenStutterCount: 1,
    avgLatencyMs: 560,
    reconnectCount: 1.2,
    startTime: '2026-02-11 15:30:32',
    endTime: '2026-02-11 15:56:40',
    duration: '26分钟7秒',
    participants: 7,
    videoEnabled: false,
    screenEnabled: true,
    recordEnabled: false
  },
  {
    id: '178756',
    topic: '程哲的快速会议',
    creator: '程哲',
    account: 'chengzhe1',
    overall: { status: '好', score: 97.56 },
    audio: { status: '好', score: 98 },
    video: { status: '—' },
    screen: { status: '—' },
    network: { status: '好', score: 97.11 },
    loginSuccessRate: 98.32,
    audioStutterRate: 0.45,
    audioStutterCount: 1,
    videoStutterRate: 0.45,
    videoStutterCount: 1,
    screenStutterRate: 0.45,
    screenStutterCount: 1,
    avgLatencyMs: 580,
    reconnectCount: 1,
    startTime: '2026-02-11 14:31:35',
    endTime: '2026-02-11 14:45:11',
    duration: '13分钟32秒',
    participants: 3,
    videoEnabled: false,
    screenEnabled: false,
    recordEnabled: false
  },
  {
    id: '780822',
    topic: '银坤的快速会议',
    creator: '银坤',
    account: 'yinkun1',
    overall: { status: '好', score: 95.28 },
    audio: { status: '好', score: 100 },
    video: { status: '—' },
    screen: { status: '好', score: 91 },
    network: { status: '好', score: 94.85 },
    loginSuccessRate: 98.32,
    audioStutterRate: 0.45,
    audioStutterCount: 1,
    videoStutterRate: 0.45,
    videoStutterCount: 1,
    screenStutterRate: 0.45,
    screenStutterCount: 1,
    avgLatencyMs: 580,
    reconnectCount: 0.8,
    startTime: '2026-02-11 14:30:11',
    endTime: '2026-02-11 14:33:05',
    duration: '2分钟54秒',
    participants: 2,
    videoEnabled: false,
    screenEnabled: true,
    recordEnabled: false
  },
  {
    id: '314289',
    topic: '马立志的快速会议',
    creator: '马立志',
    account: 'malizhi',
    overall: { status: '好', score: 97.61 },
    audio: { status: '好', score: 100 },
    video: { status: '—' },
    screen: { status: '好', score: 100 },
    network: { status: '好', score: 92.83 },
    loginSuccessRate: 98.32,
    audioStutterRate: 0.45,
    audioStutterCount: 1,
    videoStutterRate: 0.45,
    videoStutterCount: 1,
    screenStutterRate: 0.45,
    screenStutterCount: 1,
    avgLatencyMs: 580,
    reconnectCount: 2,
    startTime: '2026-02-11 14:29:53',
    endTime: '2026-02-11 14:38:27',
    duration: '8分钟32秒',
    participants: 2,
    videoEnabled: false,
    screenEnabled: true,
    recordEnabled: false
  },
  {
    id: '468902',
    topic: '河南项目',
    creator: '张明',
    account: '13141234699',
    overall: { status: '好', score: 98.91 },
    audio: { status: '好', score: 99 },
    video: { status: '—' },
    screen: { status: '—' },
    network: { status: '好', score: 98.82 },
    loginSuccessRate: 98.32,
    audioStutterRate: 0.45,
    audioStutterCount: 1,
    videoStutterRate: 0.45,
    videoStutterCount: 1,
    screenStutterRate: 0.45,
    screenStutterCount: 1,
    avgLatencyMs: 580,
    reconnectCount: 0,
    startTime: '2026-02-11 13:52:45',
    endTime: '2026-02-11 15:10:04',
    duration: '1小时14分钟27秒',
    participants: 2,
    videoEnabled: false,
    screenEnabled: false,
    recordEnabled: false
  },
  {
    id: '186260',
    topic: '史占英的快速会议',
    creator: '史占英',
    account: 'shizhanying',
    overall: { status: '好', score: 99.96 },
    audio: { status: '好', score: 100 },
    video: { status: '—' },
    screen: { status: '好', score: 100 },
    network: { status: '好', score: 99.89 },
    loginSuccessRate: 98.32,
    audioStutterRate: 0.45,
    audioStutterCount: 1,
    videoStutterRate: 0.45,
    videoStutterCount: 1,
    screenStutterRate: 0.45,
    screenStutterCount: 1,
    avgLatencyMs: 580,
    reconnectCount: 3.5,
    startTime: '2026-02-11 11:29:42',
    endTime: '2026-02-11 12:03:22',
    duration: '33分钟39秒',
    participants: 2,
    videoEnabled: false,
    screenEnabled: true,
    recordEnabled: false
  },
  {
    id: '599300',
    topic: '韩财兴预定的会议',
    creator: '韩财兴',
    account: 'hancaixing',
    overall: { status: '好', score: 99.99 },
    audio: { status: '好', score: 100 },
    video: { status: '—' },
    screen: { status: '好', score: 100 },
    network: { status: '好', score: 99.96 },
    loginSuccessRate: 98.32,
    audioStutterRate: 0.45,
    audioStutterCount: 1,
    videoStutterRate: 0.45,
    videoStutterCount: 1,
    screenStutterRate: 0.45,
    screenStutterCount: 1,
    avgLatencyMs: 580,
    reconnectCount: 1,
    startTime: '2026-02-11 11:25:54',
    endTime: '2026-02-11 12:11:13',
    duration: '45分钟18秒',
    participants: 5,
    videoEnabled: false,
    screenEnabled: true,
    recordEnabled: false
  },
  {
    id: '504821',
    topic: '陈琪的快速会议',
    creator: '陈琪',
    account: 'chengi7',
    overall: { status: '好', score: 91.13 },
    audio: { status: '好', score: 95 },
    video: { status: '—' },
    screen: { status: '一般', score: 84 },
    network: { status: '好', score: 94.4 },
    loginSuccessRate: 98.32,
    audioStutterRate: 0.45,
    audioStutterCount: 1,
    videoStutterRate: 0.45,
    videoStutterCount: 1,
    screenStutterRate: 0.45,
    screenStutterCount: 1,
    avgLatencyMs: 580,
    reconnectCount: 1,
    startTime: '2026-02-11 11:04:09',
    endTime: '2026-02-11 11:23:28',
    duration: '19分钟18秒',
    participants: 2,
    videoEnabled: false,
    screenEnabled: true,
    recordEnabled: false
  },
  {
    id: '113429',
    topic: '任开心的快速会议',
    creator: '任开心',
    account: 'renkaixin',
    overall: { status: '好', score: 96.01 },
    audio: { status: '好', score: 90 },
    video: { status: '—' },
    screen: { status: '好', score: 100 },
    network: { status: '好', score: 98.03 },
    loginSuccessRate: 98.32,
    audioStutterRate: 0.45,
    audioStutterCount: 1,
    videoStutterRate: 0.45,
    videoStutterCount: 1,
    screenStutterRate: 0.45,
    screenStutterCount: 1,
    avgLatencyMs: 580,
    reconnectCount: 1,
    startTime: '2026-02-11 10:48:30',
    endTime: '2026-02-11 11:01:38',
    duration: '13分钟7秒',
    participants: 2,
    videoEnabled: false,
    screenEnabled: true,
    recordEnabled: false
  },
  {
    id: '069801',
    topic: '张艳冲的快速会议',
    creator: '张艳冲',
    account: '15811384690',
    overall: { status: '好', score: 97.45 },
    audio: { status: '好', score: 100 },
    video: { status: '—' },
    screen: { status: '好', score: 100 },
    network: { status: '好', score: 92.34 },
    loginSuccessRate: 98.32,
    audioStutterRate: 0.45,
    audioStutterCount: 1,
    videoStutterRate: 0.45,
    videoStutterCount: 1,
    screenStutterRate: 0.45,
    screenStutterCount: 1,
    avgLatencyMs: 580,
    reconnectCount: 1,
    startTime: '2026-02-11 10:48:02',
    endTime: '2026-02-11 10:55:12',
    duration: '7分钟9秒',
    participants: 2,
    videoEnabled: false,
    screenEnabled: true,
    recordEnabled: false
  }
];

const HistoricalMeetings: React.FC = () => {
  const loginSuccessDesc = '5s内加入会议成功人次/尝试加入会议人次';
  const audioStutterDesc = '音频卡顿超过200ms的时长 / 按流计算的总视频时长 × 100%（会议内卡顿总次数）';
  const videoStutterDesc = '视频卡顿超过500ms的时长 / 按流计算的总视频时长 × 100%（会议内卡顿总次数）';
  const screenStutterDesc = '屏幕共享卡顿超过1000ms的时长 / 按流计算的总视频时长 × 100%（会议内卡顿总次数）';

  const tabs = ['最近7天', '最近30天', '本月', '上月', '本年', '自定义'];
  const meetings = historicalMeetingRecords;
  const {
    total,
    page,
    pageCount,
    pageSize,
    pagedRows,
    setPage,
    setPageSize
  } = useTablePagination(meetings);

  const renderQuality = (quality: MeetingQuality) => {
    if (quality.status === '—') {
      return <span className="quality-empty">—</span>;
    }
    const colorClass = quality.status === '好' ? 'good' : 'normal';
    return (
      <span className={`quality-chip ${colorClass}`}>
        <span className="quality-dot" />
        {quality.status} ({quality.score})
      </span>
    );
  };

  const renderFlag = (enabled: boolean) => (
    <span className={`flag-chip ${enabled ? 'enabled' : 'disabled'}`}>
      {enabled ? '已启用' : '未启用'}
    </span>
  );

  const formatPercent = (value: NullableNumber) => {
    if (value === null) {
      return '—';
    }
    return Number.isInteger(value) ? `${value}%` : `${value.toFixed(2)}%`;
  };

  const formatCount = (value: NullableNumber) => {
    if (value === null) {
      return '—';
    }
    return Number.isInteger(value) ? `${value}` : value.toFixed(1);
  };

  const renderRateWithCount = (rate: NullableNumber, count: NullableNumber) => {
    if (rate === null || count === null) {
      return <span className="quality-empty">—</span>;
    }
    return (
      <span className="metric-cell">
        {`${rate.toFixed(2)}% (${formatCount(count)}次)`}
      </span>
    );
  };

  const renderLatency = (value: NullableNumber) => (
    value === null ? <span className="quality-empty">—</span> : `${value}ms`
  );

  return (
    <div className="page-block">
      <div className="breadcrumb">
        <span>会议</span>
        <span className="breadcrumb-sep" aria-hidden="true">›</span>
        <Link to="/historical" className="breadcrumb-link">历史会议</Link>
      </div>
      <div className="page-card">
        <div className="tab-list">
          {tabs.map((tab, index) => (
            <button
              key={tab}
              type="button"
              className={`tab-button ${index === 0 ? 'active' : ''}`}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className="toolbar toolbar-bottom">
          <div className="toolbar-left">
            <select className="toolbar-select">
              <option>会议ID</option>
              <option>主题</option>
              <option>创建者</option>
            </select>
            <input className="toolbar-input" placeholder="请输入" />
            <button type="button" className="toolbar-icon" aria-label="搜索">
              <span className="icon icon-search" />
            </button>
            <button type="button" className="toolbar-icon" aria-label="刷新">
              <span className="icon icon-refresh" />
            </button>
          </div>
          <button type="button" className="toolbar-export">
            <span className="icon icon-download" />
          </button>
        </div>

        <div className="table-container">
          <table className="compact-table">
            <thead>
              <tr>
                <th>会议ID</th>
                <th>主题</th>
                <th className="creator-col">创建者</th>
                <th>账号</th>
                <th>整体质量</th>
                <th>音频质量</th>
                <th>视频质量</th>
                <th>共享屏幕质量</th>
                <th>网络质量</th>
                <th><MetricHeader label="5s登录成功率" description={loginSuccessDesc} /></th>
                <th><MetricHeader label="音频卡顿率（次数）" description={audioStutterDesc} /></th>
                <th><MetricHeader label="视频卡顿率（次数）" description={videoStutterDesc} /></th>
                <th><MetricHeader label="屏幕共享卡顿率（次数）" description={screenStutterDesc} /></th>
                <th>平均延迟</th>
                <th>重连次数</th>
                <th>开始时间</th>
                <th>结束时间</th>
                <th>时长</th>
                <th>参与者</th>
                <th>视频</th>
                <th>屏幕共享</th>
                <th>录制</th>
              </tr>
            </thead>
            <tbody>
              {pagedRows.map(item => (
                <tr key={item.id}>
                  <td>
                    <Link to={`/historical/${item.id}`} className="link-text meeting-id-link">
                      {item.id}
                    </Link>
                  </td>
                  <td>{item.topic}</td>
                  <td className="creator-col">{item.creator}</td>
                  <td>{item.account}</td>
                  <td className="nowrap-cell">{renderQuality(item.overall)}</td>
                  <td className="nowrap-cell">{renderQuality(item.audio)}</td>
                  <td className="nowrap-cell">{renderQuality(item.video)}</td>
                  <td className="nowrap-cell">{renderQuality(item.screen)}</td>
                  <td className="nowrap-cell">{renderQuality(item.network)}</td>
                  <td className="metric-cell nowrap-cell">{formatPercent(item.loginSuccessRate)}</td>
                  <td className="nowrap-cell">{renderRateWithCount(item.audioStutterRate, item.audioStutterCount)}</td>
                  <td className="nowrap-cell">{renderRateWithCount(item.videoStutterRate, item.videoStutterCount)}</td>
                  <td className="nowrap-cell">{renderRateWithCount(item.screenStutterRate, item.screenStutterCount)}</td>
                  <td className="metric-cell nowrap-cell">{renderLatency(item.avgLatencyMs)}</td>
                  <td className="metric-cell nowrap-cell">{formatCount(item.reconnectCount)}</td>
                  <td>{item.startTime}</td>
                  <td>{item.endTime}</td>
                  <td>{item.duration}</td>
                  <td>{item.participants}</td>
                  <td className="nowrap-cell">{renderFlag(item.videoEnabled)}</td>
                  <td className="nowrap-cell">{renderFlag(item.screenEnabled)}</td>
                  <td className="nowrap-cell">{renderFlag(item.recordEnabled)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <TablePagination
          total={total}
          page={page}
          pageCount={pageCount}
          pageSize={pageSize}
          onPageChange={setPage}
          onPageSizeChange={setPageSize}
        />
      </div>
    </div>
  );
};

export default HistoricalMeetings;
